import './Footer.css';

function Footer() {
    return(
        <footer className="footer">
        ELGAR | ALLAN 2024
    </footer>
    )
        
}

export default Footer;